import Api from "./base/api-base";

export default class NotificationsApi {
  //お知らせ情報一覧取得
  list() {
    return Api.get({
      endpoint: Api.endpoint.notifications
    });
  }

  //お知らせ情報削除
  delete(id) {
    return Api.delete({
        endpoint: Api.endpoint.notifications,
        id: id
    });
  }

  //お知らせ情報取得
  info(id) {
    return Api.get({
      endpoint: Api.endpoint.notifications,
      id: id,
    });
  }

  //お知らせ情報更新
  update(id, params) {
    return Api.post({
      endpoint: Api.endpoint.notifications,
      id: id,
      params: params
    });
  }

  //お知らせ情報登録
  store(params) {
      return Api.post({
          endpoint: Api.endpoint.notifications,
          params: params
      });
  }
}
